// Globally register all base components for convenience, because they
// will be used very frequently. Components are registered using the
// PascalCased version of their file name.

import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import ToggleButton from 'vue-js-toggle-button'
import VeeValidate from 'vee-validate'

Vue.use(BootstrapVue)
Vue.use(ToggleButton)
Vue.use(VeeValidate, {
  fieldsBagName: 'formFields',
})

VeeValidate.Validator.extend('verify_password', {
  getMessage: (field) => `Password is too weak`,
  validate: (value) => {
    var strongRegex = new RegExp(
      '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})'
    )
    return strongRegex.test(value)
  },
})

// https://webpack.js.org/guides/dependency-management/#require-context
const requireComponent = require.context(
  // Look for files in the current directory
  '.',
  // Do not look in subdirectories
  true,
  // Only include "_base-" prefixed .vue files
  /_base-[\w-]+\.vue$/
)

// For each matching file name...
requireComponent.keys().forEach((fileName) => {
  var newres = fileName
    .split('')
    .slice(fileName.indexOf('/'), fileName.lastIndexOf('/'))
    .join('')
  // Get the component config
  const componentConfig = requireComponent(fileName)

  // Get the PascalCase version of the component name
  const componentName = upperFirst(
    camelCase(
      fileName

        // Remove the "./_" from the beginning
        .replace(newres, '')
        // Remove the file extension from the end
        .replace(/\.\w+$/, '')
    )
  )
  // console.log("componentName", componentName)
  // Globally register the component
  Vue.component(componentName, componentConfig.default || componentConfig)
})
